import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { LabelHttpService } from '@services/http/label.http.service';
import { TuiDataList, TuiFilterByInputPipe, TuiInput } from '@taiga-ui/core';
import { TuiDataListWrapper, TuiHideSelectedPipe, TuiInputChip } from '@taiga-ui/kit';
import { AutoCompleteLabelModel } from 'src/app/shared/models/helpers/auto-complete-label-model';
import { FavoriteLabelsComponent } from '../favorite-labels/favorite-labels.component';

@Component({
  selector: 'pxc-select-label',
  templateUrl: './select-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FavoriteLabelsComponent,
    TuiInput,
    TuiInputChip,
    TuiDataList,
    TuiDataListWrapper,
    TuiFilterByInputPipe,
    TuiHideSelectedPipe,
    FormsModule,
    TranslocoDirective,
  ],
  host: {
    class: 'flex flex-col gap-2',
  },
})
export class SelectLabelComponent {
  private readonly labelService = inject(LabelHttpService);

  readonly selectedLabels = input<AutoCompleteLabelModel[]>([]);
  readonly showFavoriteLabels = input(false);
  readonly autocomplete = input(true);

  readonly selectedLabelsChange = output<AutoCompleteLabelModel[]>();

  readonly value = computed(() => this.selectedLabels().map((selectedLabel) => selectedLabel.display));

  private readonly clientLabels = toSignal(this.labelService.getClientLabels(), { initialValue: [] });
  readonly allLabels = computed(() => this.clientLabels().map((label) => label.word));

  onLabelChange(value: string[]): void {
    const clientLabels = this.clientLabels();
    this.selectedLabelsChange.emit(
      value.map((selectedLabel) => ({
        display: selectedLabel,
        value: clientLabels.find((label) => label.word === selectedLabel) || selectedLabel,
      })),
    );
  }

  addLabel(label: string): void {
    this.onLabelChange([...this.value(), label]);
  }
}
